// extracted by mini-css-extract-plugin
module.exports = {"blockCommon":"page-header-nav__blockCommon___1KOp4","PageHeaderNav":"page-header-nav__PageHeaderNav___1JRSM"};